import React, { memo } from 'react'
import PropTypes from 'prop-types'
import PageMetaData from '@v4/utils/data/PageMetaData'

import Content from './components/Content'
import { useBanner1 } from './Banner1.hooks'

const Banner1 = props => {
	const [
		{
			classes,
			textShadow,
			contentWidth,
			opacity,
			mobileOpacity,
			backgroundImagePosition,
			desktopImage,
			mobileImage,
			direction,
			mobileImagePosition,
			mobileAlignment,
			mobileButtonWidth,

			text,
			textKey,
			textConfig,
			textEditable,

			buttonText,
			buttonLink,

			buttonAction,
			buttonTextConfig,
			buttonTextEditable,
			buttonTextKey,
		},
		{
			handleTextClick,
			handleButtonClick,
			handleTextChange,
			handleButtonTextChange,
			handleMobileImageClick,
			handleImageClick,
		},
	] = useBanner1(props)

	return (
		<Content
			classes={classes}
			desktopImage={desktopImage}
			mobileImage={mobileImage}
			direction={direction}
			backgroundImagePosition={backgroundImagePosition}
			mobileImagePosition={mobileImagePosition}
			mobileAlignment={mobileAlignment}
			mobileButtonWidth={mobileButtonWidth}
			text={text}
			textConfig={textConfig}
			buttonText={buttonText}
			contentWidth={contentWidth}
			buttonLink={buttonLink}
			buttonAction={buttonAction}
			onTextClick={handleTextClick}
			onButtonClick={handleButtonClick}
			onImageClick={handleImageClick}
			onMobileImageClick={handleMobileImageClick}
			onTextChange={handleTextChange}
			opacity={opacity}
			mobileOpacity={mobileOpacity}
			textEditable={textEditable}
			buttonTextEditable={buttonTextEditable}
			buttonTextConfig={buttonTextConfig}
			onButtonTextChange={handleButtonTextChange}
			buttonTextKey={buttonTextKey}
			textKey={textKey}
			textShadow={textShadow}
		/>
	)
}

Banner1.propTypes = {
	metaData: PropTypes.shape({
		text: PropTypes.instanceOf(PageMetaData),
		buttonAction: PropTypes.instanceOf(PageMetaData),
		buttonText: PropTypes.instanceOf(PageMetaData),
		buttonLink: PropTypes.instanceOf(PageMetaData),
		backgroundImage: PropTypes.instanceOf(PageMetaData),
		contentWidth: PropTypes.instanceOf(PageMetaData),
		backgroundImagePosition: PropTypes.instanceOf(PageMetaData),
		mobileAlignment: PropTypes.instanceOf(PageMetaData),
		mobileImagePosition: PropTypes.instanceOf(PageMetaData),
		mobileImage: PropTypes.instanceOf(PageMetaData),
		mobileButtonWidth: PropTypes.instanceOf(PageMetaData),
		overrideXsMargins: PropTypes.instanceOf(PageMetaData),
		xsMarginTop: PropTypes.instanceOf(PageMetaData),
		xsMarginBottom: PropTypes.instanceOf(PageMetaData),
	}).isRequired,
}

export default memo(Banner1)
